import React from 'react';

import { Switch, Route } from 'react-router-dom';
import Template from '../../template/template';
import useAppContext from '../../../context/useAppContext';

import FlowRouter from './flowRouter';

import ModerationFlows from '../../../pages/moderation';
import ModerationAttendees from '../../../pages/moderation/attendees/Attendees';
import ModerationProfile from '../../../pages/moderation/attendees/profile';
import OperatorsList from '../../../pages/moderation/operators';
import OperatorDetails from '../../../pages/moderation/operators/OperatorDetails';

const ModerationRouter = ({ path }) => {
    const [{ organization }] = useAppContext();

    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => (
                    <Template organization={organization}>
                        <ModerationFlows organization={organization} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/moderation_attendees`}
                render={() => (
                    <Template organization={organization}>
                        <ModerationAttendees organization={organization} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/moderation_attendees/:attendeeId`}
                render={({ match }) => (
                    <Template organization={organization}>
                        <ModerationProfile organization={organization} attendeeId={match.params.attendeeId} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/moderation_users`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorsList organizationId={organization.id} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/moderation_users/new`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorDetails organizationId={organization.id} />
                    </Template>
                )}
            />
            <Route
                exact
                path={`${path}/moderation_users/:operatorId`}
                render={({ match }) => (
                    <Template organization={organization} moderationFlowId={match.params.flowId}>
                        <OperatorDetails organizationId={organization.id} operatorId={match.params.operatorId} />
                    </Template>
                )}
            />
            <Route path={`${path}/moderation_flows`} render={() => <FlowRouter organization={organization} path={`${path}/moderation_flows`} />} />
        </Switch>
    );
};

export default ModerationRouter;
